export default __webpack_public_path__ + "static/home-lj-7fb48496a27e894590db56d52c858aac.png";